import Vue from "vue";
import airlineHexColor from "@/helper/airlineColors.js";

Vue.filter("airlineColor", (value) => {
    return airlineHexColor[value];
});
